<h1 mat-dialog-title class="dialog-title">
  <mat-icon color="primary">info</mat-icon>
  <b class="dialog-title-content">{{ categoryTitle | translate }}</b>
</h1>
<div mat-dialog-content class="dialog-content">
  <p class="dialog-content">
    {{ categoryContent | translate }}
  </p>
</div>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onNoClick()">
    {{ categoryDoNotDelete | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="onYesClick()" cdkFocusInitial [disabled]="working">
    <span [ngClass]="{ loading: working }">
      {{ categoryDoDelete | translate }}
    </span>
    <div class="spinner-container" *ngIf="working">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  </button>
</mat-dialog-actions>
